export default (
  state = {
    abstractData: {},
    loadAbstract: false,
    refreshAbstract: false
  },
  action
) => {
  switch (action.type) {
    case 'START_LOAD_ABSTRACT':
      return {
        ...state,
        loadAbstract: true
      }

    case 'STOP_LOAD_ABSTRACT':
      return {
        ...state,
        loadAbstract: false
      }

    case 'REFRESH_ABSTRACT':
      return {
        ...state,
        refreshAbstract: action.refreshAbstract
      }
    default:
      return state
  }
}